import React, { useState, useEffect } from "react";
import { Section, LoaderFullPage } from "../../../components";
import { ModalForm, FormInput } from "../../../components2";
import SearchStore from "../components/SearchStore";
// import { useSelector } from "react-redux";
import { shopUpdate } from "../../../lib/ec2-api-lib";
import { isJson } from "../../../lib/utils";
import { debug } from "../../../settings";

export function RegisterFC(props) {
  // const { isMobileDevice } = useSelector(state => state.platform)

  const [isLoading, setIsLoading] = useState(false);
  const [shopInfo, setShopInfo] = useState({})
  const [visible, setVisible] = useState(false)

  const onSelectShop = async (shop) => {
    try {
      // console.log('shop', shop)
      setShopInfo(shop)
      setVisible(true)
    } catch (e) {
      alert(e.message)
      if (debug) console.log(e)
    }
  }

  return (
    <Section bgColor="#fff">

      <SearchStore
        onSelectStore={onSelectShop}
        defaultValue={debug ? "샤브온당" : ""}
      />

      {shopInfo.shopId &&
        <ShopModal
          {...props}
          shopInfo={shopInfo}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          visible={visible}
          setVisible={setVisible}
        />
      }

      {isLoading && <LoaderFullPage />}
    </Section>
  );
}

function ShopModal(props) {
  const { shopInfo } = props

  const [brandName, setBrandName] = useState("")
  const [isBase, setIsBase] = useState(false)

  useEffect(() => {
    const brand = isJson(shopInfo.brandInfo) ? JSON.parse(shopInfo.brandInfo) : {}
    // console.log(brand)
    setBrandName(brand.name || "")
    setIsBase(brand.isBase === true)
  }, [shopInfo])

  const onSubmit = async () => {
    try {
      props.setIsLoading(true)

      const brandData = {
        name: brandName,
        isBase
      }

      // alert(JSON.stringify(brandData, null, 2))

      let res = await shopUpdate({
        shopId: shopInfo.shopId,
        body: {
          brandInfo: JSON.stringify(brandData)
        }
      })

      if (res.err) throw Error(res.err.message)
    } catch (e) {
      alert(e.message)
    } finally {
      props.setIsLoading(false)
      props.setVisible(false)
    }
  }

  const styles = {
    formGroup: { margin: "15px 5px" }
  }

  return (
    <ModalForm
      visible={props.visible}
      setIsVisible={props.setVisible}
      title={shopInfo.shopName}
      onSubmit={onSubmit}
      isLoading={props.isLoading}
      size="md"
    >
      <div style={styles.formGroup}>
        <FormInput
          name="name"
          label="브랜드 이름"
          value={brandName}
          onChange={(e) => setBrandName(e.target.value)}
        />

        <FormInput
          name="isBase"
          label="참고 스토어 여부"
          inputType="checkbox"
          checked={isBase}
          onChange={(e) => setIsBase(!isBase)}
        />
      </div>
    </ModalForm>
  )
}